import React, { Component } from "react";
import "./Losange.css";

export default function Losange(props) {
  return (
    <div
      className="step"
      style={{
        minWidth: props.losangeWith,
        maxWidth: props.losangeWith,
        minHeight: props.losangeHeight,
        maxHeight: props.losangeHeight,
      }}
    >
      <div style ={{
         minWidth: props.losangeWith,
         maxWidth: props.losangeWith,
         minHeight: props.losangeHeight,
         maxHeight: props.losangeHeight,
      }} >{props.title}</div>
    </div>
  );
}
